<template>
  <div>
    <el-form :ref="formName" :model="formDataBind" :rules="formRules" :label-width="labelWidth" class="filterForm"
             @keyup.enter.native="handleSearch">
      <!-- <el-row> -->
      <div class="search-left">
        <el-row>
          <!-- 不分组 -->
          <el-col :span="column.span||12" v-for="(column,idx) in formColumns" :key="idx"
                  v-if="checkConditions(column.conditions)">
            <el-form-item :label="column.label+'：'" :prop="column.field">
              <template v-if="column.component">
                <template v-if="column.component == 'image-upload' ">
                  <component
                    :is="column.component"
                    :field="column.field"
                    :options="column.options"
                    :type="column.type"
                    :v-bind="column.props||{}"
                    :placeholder="column.placeholder"
                    @onSuccess="onImageUploadSuccess">
                  </component>
                </template>
                <template v-else>
                  <component
                    :is="column.component"
                    v-model="formDataBind[column.field]"
                    :options="column.options"
                    :type="column.type"
                    :placeholder="column.placeholder"
                    :value-format="column.valueFormat"
                    :filterable="column.filterable"
                    :picker-options="column.pickerOptions"
                    :maxlength="column.maxLength"
                    :minlength="column.minLength"
                    :v-bind="column.props||{}"
                  >
                    <el-option
                      v-for="(item, idx2) in column.options"
                      :key="item.key||item.value"
                      :label="item.label"
                      :value="item.value"
                      v-if="column.component == 'el-select'"
                    />
                  </component>

                </template>
              </template>
              <template v-else>
                {{formDataBind[column.field]}}
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="search-right">
        <el-row>
          <el-col>
            <el-form-item label-width="20px">
              <el-button
                :type="button.type"
                :class="button.class"
                :size="button.size||'small'"
                v-for="(button,idx3) in formButtons"
                :key="idx3"
                @click="button.clickHandler($refs[formName])"
              >
                {{button.label}}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <slot></slot>
      <!-- </el-row> -->
    </el-form>
  </div>
</template>

<script>
  export default {
    name: "FilterFormBuildComponent",
    data() {
      return {}
    },
    props: {
      label: String,
      labelWidth: {
        type: String,
        default: '150px'
      },
      border: {
        type: Boolean,
        default: false
      },
      formColumns: {
        type: Array,
        default: () => {
          return []
        }
      },
      formColumnsGroup: {
        type: Array,
        default: () => {
          return []
        }
      },
      formName: {
        type: String,
        default: 'FormName'
      },
      formData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      formRules: {
        type: Object,
        default: () => {
          return {}
        }
      },
      formButtons: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    computed: {
      formDataBind: {
        get() {
          return this.formData
        },
        set(newVal) {
          this.$emit('update:formData', newVal)
        }
      }
    },
    methods: {
      onImageUploadSuccess: function (res) {
        try {
          this.formDataBind[res.field] = res.res.albumId + '/' + res.res.images[0].imageId
        } catch (e) {

        }
      },
      checkConditions: function (conditions) {
        if (typeof conditions == 'undefined') {
          return true
        } else if (typeof conditions == 'Boolean') {
          return conditions
        } else if (typeof conditions == 'function') {
          return conditions.apply(this)
        } else if (Array.isArray(conditions)) {
          return conditions.every(condition => this.checkConditions(condition))
        }
      },
      handleSearch: function () {
        return ((this.formButtons || [])[0] || {}).clickHandler(this.$refs[this.formName])
    }
  }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FilterFormBuild.vue